export default {
  data: () => ({

    rawData:  [],
    
    header:   {},
    table:    {},
    columns:  [],
    total:    {},
    keys:     {},
    filter:   {},
    
    canvasForms:  null,
    canvasChart:  null,
  }),




  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },
}